import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { UrlResp } from './UrlResp';

@Injectable()
export class BrokerInitService {


      constructor(private httpclient: HttpClient) { }

      // calls login service
      getBroker() {
            return this.httpclient.post<UrlResp>('/broker/getBroker', {}).map(data => data);
      }

      getNativeWindow() {
            return window;
      }
}
